<template>
      <div role="status" class="w-full app-container pb-14 mt-5 md:pb-20 lg:pb-24 bg-[#fff]">
        <div class="flex gap-2 py-8">
              <div v-for="(_, index) in Array.from({length: 3})" :key="index" >
                <div class="animate-pulse h-3 w-[70px] bg-gray-200 dark:bg-gray-700 rounded-full mb-3" />
              </div>
          </div>
        <div
          class="w-full flex flex-wrap gap-x-4 gap-y-5 sm:grid sm:flex-auto lg:grid-cols-2 md:gap-8 mt-3 mb-4"
        >
          <!-- Right Side -->
        <div
              class="w-full flex flex-col justify-center max-h-[908px] md:top-[80px]"
            >
            <!-- main image viewer -->
            <div
              class="single_product_viewer"
            >
              <div
                class="animate-pulse bg-gray-200 dark:bg-gray-700 flex justify-center items-center w-full max-w-aut md:max-w-[450px] h-[255px] sm:h-[350px] lg:h-[550px] object-contain select-none max-h-[690px] md:max-h-[60vh] md:min-w-[150px] lg:max-w-none mx-auto"
              >
              </div>
            </div>
            <!-- image selector -->
            <div class="mt-7 sm:mt-6 md:mt-10 slider-container overflow-hidden">
                <div class="flex flex-nowrap gap-2">
                  <div v-for="(_, index) in Array.from({length: 8})" :key="index" class="animate-pulse bg-gray-200 dark:bg-gray-700 m-0 p-0 select-none w-[75px] h-[75px] md:w-[97px] md:h-[97px] lg:w-[105px] lg:h-[105px]"/>
                </div>
            </div>
        </div>

          <!-- Left Side -->
          <div class="w-full">
            <div class="flex flex-wrap w-full justify-between items-center gap-x-2 gap-y-3">
              <!-- product name -->
              <div class="animate-pulse h-[10px] w-[200px] rounded-md bg-gray-200 dark:bg-gray-600"/>
              <!-- buttons group -->
              <div class="flex flex-wrap items-center gap-2.5 md:gap-3.5">
                <div v-for="(_, index) in Array.from({length: 3})" :key="index" class="animate-pulse bg-gray-200 dark:bg-gray-700 rounded-full m-0 p-0 select-none w-[24px] h-[24px] lg:w-[30px] lg:h-[30px]"/>
              </div>
            </div>  
            <!-- Rating -->
            <div class="animate-pulse h-[8px] w-[60px] rounded-md mt-3 bg-gray-200 dark:bg-gray-600"/>  
            <!-- Price -->
            <div class="animate-pulse w-full bg-gray-200 dark:bg-gray-600 flex flex-col mt-5 h-[55px] md:h-[58px] py-3 px-4 gap-0.5 rounded-[3px]"/>
            <!-- description -->
            <div class="animate-pulse w-[120px] bg-gray-200/80 dark:bg-gray-600 flex flex-col mt-3 h-[35px] md:h-[37px] py-3 px-4 gap-0.5 rounded-[3px]"/>
            <div class="mt-3">
                <div class="animate-pulse h-2 bg-gray-200 rounded-[1px] dark:bg-gray-700 max-w-[20%] mb-2"></div>
                <div class="animate-pulse h-2 bg-gray-200 rounded-[1px] dark:bg-gray-700 max-w-[100%] mb-2"></div>
                <div class="animate-pulse h-2 bg-gray-200 rounded-[1px] dark:bg-gray-700 max-w-[90%] mb-2"></div>
                <div class="animate-pulse h-2 bg-gray-200 rounded-[1px] dark:bg-gray-700 max-w-[70%] mb-2"></div>
                <div class="animate-pulse h-2 bg-gray-200 rounded-[1px] dark:bg-gray-700 max-w-[40%] mb-2"></div>
            </div>
            <!-- specifications -->
            <div class="animate-pulse w-[120px] bg-gray-200/80 dark:bg-gray-600 flex flex-col mt-3 h-[35px] md:h-[37px] py-3 px-4 gap-0.5 rounded-[3px]"/>
            <div class="mt-4">
              <div class="animate-pulse w-full bg-gray-200/50 dark:bg-gray-600 flex flex-col mb-1 h-[35px] md:h-[37px] py-3 px-4 gap-0.5 rounded-[3px]"/>
              <div class="animate-pulse w-full bg-gray-200/70 dark:bg-gray-600 flex flex-col mb-1 h-[35px] md:h-[37px] py-3 px-4 gap-0.5 rounded-[3px]"/>
              <div class="animate-pulse w-full bg-gray-200/50 dark:bg-gray-600 flex flex-col mb-1 h-[35px] md:h-[37px] py-3 px-4 gap-0.5 rounded-[3px]"/>
            </div>
            <!-- store info -->
            <div class="animate-pulse w-full bg-gray-200/60 dark:bg-gray-600 mt-4 flex flex-col mb-1.5 h-[84px] md:h-[87px] py-3 px-4 gap-0.5 rounded-[3px]"/>
            <!-- buttons group -->
            <div class="flex flex-wrap justify-center gap-5 mt-6">
                <div v-for="(_, index) in Array.from({length: 3})" :key="index" class="animate-pulse bg-gray-200/80 dark:bg-gray-700 rounded-[22px] m-0 p-0 select-none w-[180px] h-[34px] lg:w-[180px] lg:h-[40px]"/>
            </div>
          </div>
        </div>
        <!-- report button -->
        <div class="animate-pulse w-[120px] bg-gray-200/40 dark:bg-gray-600 flex flex-col mt-7 h-[20px] md:h-[20px] py-3 px-4 gap-0.5"/>
        <!-- rate section -->
        <div class="animate-pulse w-full bg-gray-200/50 dark:bg-gray-600 flex flex-col mt-8 h-[35px] md:h-[37px] py-3 px-4 gap-0.5 rounded-[3px]"/>
        <span class="sr-only">Loading...</span>
      </div>
</template>

<script>
export default {

}
</script>

<style scoped>
.single_product_viewer {
  flex: 1;
  display: grid;
  place-items: center;
}

.slider-container {
  display: flex;
  position: relative;
  min-height: 50px;
}
</style>